/** Fortify Refund Policy */

import { GENERAL_INQUIRIES_EMAIL, WITHDRAWAL_NOTICE_EMAIL } from "lib/fortifyContact";

export const refundPolicyMeta = {
  company: "FORTIFY PORTAL, INC.",
  title: "Refund Policy",
  contactLine: `fortifyportal.ca | ${GENERAL_INQUIRIES_EMAIL}`,
};

export const refundPolicySections = [
  {
    number: "1",
    title: "Application",
    paragraphs: [
      'This Refund Policy applies to all investments made through the Fortify portal (the "Platform"), operated by Fortify Portal, Inc. ("Fortify"), in reliance on the start-up crowdfunding prospectus exemption in National Instrument 45-110 ("NI 45-110").',
    ],
  },
  {
    number: "2",
    title: "Issuer Fees",
    paragraphs: [
      "Fortify Portal, Inc. does not refund fees paid by Issuers using the Platform to raise capital, except as expressly provided in the Platform-Issuer Agreement between Fortify Portal, Inc. and the Issuer.",
    ],
  },
  {
    number: "3",
    title: "Investor Cancellation Right",
    paragraphs: [
      `An investor has the right to cancel an agreement to purchase securities through the Platform by delivering a notice of cancellation to Fortify Portal, Inc. at ${WITHDRAWAL_NOTICE_EMAIL}:`,
    ],
    listItems: [
      "Not later than midnight Eastern Time on the second business day after the day on which the investor enters into the agreement to purchase the securities; and",
      "Not later than midnight Eastern Time on the second business day after the day on which Fortify Portal, Inc. notifies the investor of any amendment to the offering document.",
    ],
    paragraphsAfterList: [
      "If notice of cancellation is not received within these periods, the investor will no longer be able to cancel the investment.",
    ],
  },
  {
    number: "4",
    title: "Refund of Cancelled Investment",
    paragraphs: [
      "If an investor exercises the right to cancel under Section 3, Fortify Portal, Inc. will refund any funds transferred by the investor in respect of the cancelled investment, without deduction, within five (5) business days after receipt of the notice of cancellation. Refunds are made to the original payment source.",
    ],
  },
  {
    number: "5",
    title: "Failed Offering",
    paragraphs: [
      "If an Issuer fails to meet the minimum offering amount stated in its offering document by the offering deadline (or such earlier date on which the Issuer withdraws the offering), Fortify Portal, Inc. will return all subscription funds held in trust to the investors who paid them, without deduction, within five (5) business days after that date.",
    ],
  },
  {
    number: "6",
    title: "Discontinuation of the Platform",
    paragraphs: ["If at any time:"],
    listItems: [
      "Fortify Portal, Inc. makes a general assignment for the benefit of its creditors;",
      "Fortify Portal, Inc. commences or institutes any application, proceeding, or other action under any law relating to bankruptcy, insolvency, or winding-up; or",
      "the operations of the Platform are discontinued for any reason,",
    ],
    paragraphsAfterList: [
      "then within two (2) business days of the occurrence of any such event, Fortify Portal, Inc. will notify all investors who have funds held by Fortify Portal, Inc., all Issuers conducting an offering on the Platform, and the applicable securities regulatory authority of the event and how it will affect them.",
      "In the case of a discontinuation of the Platform's operations, Fortify Portal, Inc. will return to investors, within five (5) business days, all subscription funds it holds in trust, other than funds that are properly due to an Issuer in respect of an offering that has met all conditions for closing.",
    ],
  },
  {
    number: "7",
    title: "Amendments",
    paragraphs: [
      "Fortify Portal, Inc. may amend this Policy from time to time on notice posted on the Platform. The version of this Policy in effect at the time of an investor's subscription governs that subscription.",
    ],
  },
  {
    number: "8",
    title: "Contact",
    paragraphs: [
      "Questions regarding this Refund Policy should be directed to:",
      "Fortify Portal, Inc.",
      "1377 The Queensway, Unit 101, Toronto, Ontario M8Z 1T1",
    ],
    contactLines: [
      {
        label: "Email:",
        value: GENERAL_INQUIRIES_EMAIL,
        href: `mailto:${GENERAL_INQUIRIES_EMAIL}`,
      },
    ],
  },
];
